<template>
  <div>
    <div v-if="!isLoad">
      <v-main class="" style="padding: 0px">
        <LearningDashboard />
      </v-main>
    </div>
    <div v-else class="absolute w-full h-screen flex-col items-center flex justify-center">
      <v-progress-circular
        :color="$vuetify.theme.currentTheme.primary"
        indeterminate
        :size="50"
        :width="5"
      ></v-progress-circular>
      <div class="mt-2"><span>Please Wait...</span></div>
    </div>
  </div>
</template>

<script>
import LearningDashboard from '~/components/Workforce/Learning/LearningDashboard.vue'

export default {
  name: 'LearningPage',
  layout: 'Workforce/default',
  components: {
    LearningDashboard
  },
  data() {
    return {
      isLoad: true
    }
  },
  computed: {},
  methods: {},
  mounted() {
    this.isLoad = false
  }
}
</script>

<style scoped></style>
